import React, { useEffect } from "react";
import useGiftCard from "./hooks/useGiftCard";
import SingleGiftCard from "./single-gift-card";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../store";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";

const GiftCard: React.FC = () => {
  const { acceptTransaction, tickets } = useGiftCard();
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  useEffect(() => {
    acceptTransaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <EAPageHeader componentId="GiftCardActive" />
      <EAPageMessage message={saleConfiguration.message_giftCards} />

      <div className="flex-between flex-wrap">
        {tickets.length > 0 ? (
          <>
            {tickets.map((item, index) => (
              <SingleGiftCard item={item} key={index} />
            ))}
          </>
        ) : (
          <div className="alert alert-yellow">
            <b>{t("brak_aktywnych_kart_podarunkowych")}</b>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftCard;
